export enum CredentialsTypes {
  PASSWORD = 'password',
  LINK = 'link',
}
